export const testimonials = [
  {
    id: 1,
    content: '与木瓜玩合作以来，我们的游戏在东南亚市场的DAU从10万增长到80万，广告投放ROI提升了4倍。他们的本地化运营能力非常出色。',
    author: '张伟',
    role: '运营总监',
    company: '星辰游戏工作室',
  },
  {
    id: 2,
    content: '木瓜玩的创意素材团队给我们的SLG游戏制作的可玩广告，点击率达到行业均值的2.5倍，获客成本降低了40%，效果远超预期。',
    author: '李明',
    role: '市场VP',
    company: '龙腾互动科技',
  },
  {
    id: 3,
    content: '他们的数据分析能力非常强，帮我们精准定位了欧美市场的高价值用户群体，7日留存率从18%提升到了35%，ROI翻了一番。',
    author: '王芳',
    role: 'CEO',
    company: '幻境游戏',
  },
];